// @flow

export const GET_DATALAYER_REQUEST = 'GET_DATALAYER_REQUEST';
export const GET_DATALAYER_SUCCESS = 'GET_DATALAYER_SUCCESS';
export const GET_DATALAYER_ERROR = 'GET_DATALAYER_ERROR';
export const CLEAR_TAG_MANAGER_RESPONSES = 'CLEAR_TAG_MANAGER_RESPONSES';
export const UPDATE_DATALAYER = 'UPDATE_DATALAYER';
export const GET_DATALAYER_AJAX_ERROR = 'GET_DATALAYER_AJAX_ERROR';
